// spy-blocker.js
(() => {
    "use strict";
    window?.SPY_BLOCKER?.settings && new class {
        constructor(e) { this.start(e) }
        start = e => {
            const t = e.settings;
            t.enabled && (t.protectTextSelection && this.protectTextSelection(),
            t.disableKeyBord && this.disableKeyBord(),
            t.protectTextCopping && this.protectTextCopping(),
            t.protectImage && this.protectImage(),
            t.disableRightClick && this.disableRightClick(),
            t.turnOffSpyExtension && this.turnOffSpyExtension(),
            t.blockInspectElements && this.blockInspectElements(t?.copyrightText ?? "", t.disableKeyBord),
            t.hideBestSellers && this.hideBestSellers(e?.page, e?.collection))
        };
        protectTextSelection = () => { document.onselectstart = () => !1 };
        disableKeyBord = () => { document.onkeydown = function(e) { return 123 !== e.keyCode && (!e.ctrlKey || e.keyCode !== "U".charCodeAt(0)) && void 0 } };
        protectTextCopping = () => { document.onpaste = () => !1, document.oncopy = () => !1, document.oncut = () => !1 };
        protectImage = () => {
            document.ondrag = () => !1,
            document.ondrop = () => !1,
            document.querySelector("head").insertAdjacentHTML("beforeend", "<style> img { -webkit-user-drag: none ; -khtml-user-drag: none; -moz-user-drag: none; -o-user-drag: none; user-drag: none; pointer-events: none; } </style>")
        };
        disableRightClick = () => { document.oncontextmenu = () => !1 };
        blockInspectElements = (e="", t=!1) => {
            document.onkeydown = function(e) {
                if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) return !1;
                if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) return !1;
                if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) return !1;
                if (t) {
                    if (123 === e.keyCode) return !1;
                    if (e.ctrlKey && e.keyCode === "U".charCodeAt(0)) return !1;
                }
            };
            const n = { isOpen: !1, orientation: void 0 }
            , o = (e, t) => { globalThis.dispatchEvent(new globalThis.CustomEvent("devtoolschange", { detail: { isOpen: e, orientation: t } })) }
            , i = ({emitEvents: e=!0}={}) => {
                const t = globalThis.outerWidth - globalThis.innerWidth > 160
                , i = globalThis.outerHeight - globalThis.innerHeight > 160
                , r = t ? "vertical" : "horizontal";
                i && t || !(globalThis.Firebug && globalThis.Firebug.chrome && globalThis.Firebug.chrome.isInitialized || t || i) ? (n.isOpen && e && o(!1, void 0), n.isOpen = !1, n.orientation = void 0) : (n.isOpen && n.orientation === r || !e || o(!0, r), n.isOpen = !0, n.orientation = r)
            };
            i({ emitEvents: !1 }),
            setInterval(i, 500),
            window.addEventListener("devtoolschange", (t => {
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || t.detail.isOpen && (alert(e), console.log(`%c ${e}`, "font-size:32px;"))
            }));
        };
        turnOffSpyExtension = () => {
            document.querySelector("head").insertAdjacentHTML("beforeend", '<style> div[style*="2147483647"]{display:none !important;} .extension-container{display:none !important;} .ppspy-container{display:none !important;} </style>');
            let e = (new Date).getTime(), t = setInterval((function() {
                if ((new Date).getTime() - e > 15e3) return clearInterval(t);
                let n = document.querySelectorAll("div");
                for (let e = 0; e < n.length; e++) "2147483647" === document.querySelectorAll("div")[e].style.Zindex && document.querySelectorAll("div")[e].parentNode.parentNode.parentNode.remove()
            }), 500);
            window.addEventListener("load", (function() { [...document.getElementsByClassName("extension-container")].forEach((e => e.style.display = "none")) }));
        };
        hideBestSellers = (e, t) => { "collection" === e && t?.handle?.length && Array.from(document.querySelectorAll('select[name="sort_by"] [value="best-selling"]')).map((e => e.remove())) };
    }(window.SPY_BLOCKER)
})();
